import { render, staticRenderFns } from "./BlockNavigationUser.vue?vue&type=template&id=770a5a3a&scoped=true&"
import script from "./BlockNavigationUser.vue?vue&type=script&lang=js&"
export * from "./BlockNavigationUser.vue?vue&type=script&lang=js&"
import style0 from "./BlockNavigationUser.vue?vue&type=style&index=0&id=770a5a3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770a5a3a",
  null
  
)

export default component.exports